var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex"},[_c('h1',[_vm._v("404-没找到！")]),_c('div',{staticClass:"but",on:{"click":_vm.onClick}},[_vm._v("返回")])])}
var staticRenderFns = []

export { render, staticRenderFns }